import { PROD } from '../../config/stage'
import apiBaseUrl from '../baseUrl'

const stagePrefix = import.meta.env.VITE_STAGE === PROD ? '' : `${import.meta.env.VITE_STAGE}-`
// const entityApiUrl = `${apiBaseUrl}${stagePrefix}entities`

const entityApiUrl = "https://api.eidu.com/entity-dpl-content"
export default entityApiUrl
